// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-container {
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  padding: 10px;
  margin-bottom: 85px;
  top: 60px;
}

.security-change-password-container {
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  padding: 20px 10px;
  background-color: rgb(244, 247, 248);
}

.back-container {
  position: relative;
  height: 60px;
}

.centered-element {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.icon-button {
  height: 50px;
  width: 100%;
  background-color: #CC3044;
  display: flex;
  align-items: center;
  padding: 20px;
  color: #fef3f3;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-size: 18px;
}

.button-text {
  margin-left: 14px;
}

.delete {
  box-shadow: -5px 5px 15px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #ccc;
  text-align: center;
  display: flex;
  margin-top: 20px;
  border-radius: 13px;
}

.delete-h1 {
  font-weight: 200;
  padding-top: 20px;
  text-align: center;
  font-size: 17px;
  position: relative;
  line-height: 23px;
}

.delete-text {
  font-size: 15px;
  color: grey;
  text-align: center;
}

.delete-button {
  display: flex;
  margin-top: 15px;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
}

.email-selector .control-select-filter-inner {
  height: 56px;
}

.email-selector .control-select-filter-select.has-placeholder {
  color: grey;
}

.display-gap {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.border-ui {
  border: 0.5px solid #919191;
  padding: 10px;
  margin: 5px;
  padding-top: 20px;
  border-radius: 5px;
}

.nice-border {
  padding: 0px 10px;
  margin-top: 3px;
  border-radius: 10px;
}

.security-container .security-container {
  margin-bottom: 0;
}

.email-wrapper > div:nth-child(1) .control-input-holder input {
  padding-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;AACJ;;AACA;EACI,kBAAA;EACA,YAAA;AAEJ;;AAAA;EACI,SAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAGJ;;AAAE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAGJ;;AADE;EACE,iBAAA;AAIJ;;AADE;EACE,4CAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAIJ;;AAFA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EAEA,kBAAA;EACA,iBAAA;AAIJ;;AAFA;EAEI,eAAA;EACA,WAAA;EACA,kBAAA;AAIJ;;AAFA;EACI,aAAA;EACA,gBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AAIJ;;AAFA;EACI,YAAA;AAKJ;;AADA;EACI,WAAA;AAIJ;;AADA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAIJ;;AADA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAIA;;AADA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;AAIJ;;AADA;EACI,gBAAA;AAIJ;;AAFA;EACI,yBAAA;AAKJ","sourcesContent":[".security-container {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.5rem;\n  padding: 10px;\n  margin-bottom: 85px;\n  top: 60px;\n}\n\n.security-change-password-container {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1.5rem;\n  padding: 20px 10px;\n  background-color: rgb(244, 247, 248);\n}\n\n.back-container {\n  position: relative;\n  height: 60px;\n}\n\n.centered-element {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.icon-button {\n  height: 50px;\n  width: 100%;\n  background-color: #CC3044;\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  color: #fef3f3;\n  border: none;\n  border-radius: 7px;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.button-text {\n  margin-left: 14px;\n}\n\n.delete {\n  box-shadow: -5px 5px 15px rgba(0, 0, 0, 0.1);\n  border: 0.5px solid #ccc;\n  text-align: center;\n  display: flex;\n  margin-top: 20px;\n  border-radius: 13px;\n}\n\n.delete-h1 {\n  font-weight: 200;\n  padding-top: 20px;\n  text-align: center;\n  font-size: 17px;\n  position: relative;\n  line-height: 23px;\n}\n\n.delete-text {\n  font-size: 15px;\n  color: grey;\n  text-align: center;\n}\n\n.delete-button {\n  display: flex;\n  margin-top: 15px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.email-selector .control-select-filter-inner {\n  height: 56px;\n}\n\n.email-selector .control-select-filter-select.has-placeholder {\n  color: grey;\n}\n\n.display-gap {\n  display: flex;\n  flex-direction: column;\n  row-gap: 20px;\n}\n\n.border-ui {\n  border: 0.5px solid #919191;\n  padding: 10px;\n  margin: 5px;\n  padding-top: 20px;\n  border-radius: 5px;\n}\n\n.nice-border {\n  padding: 0px 10px;\n  margin-top: 3px;\n  border-radius: 10px;\n}\n\n.security-container .security-container {\n  margin-bottom: 0;\n}\n\n.email-wrapper > div:nth-child(1) .control-input-holder input {\n  padding-top: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
